//Please add the language resource
const soldCreate = {
  totalBoxQty: 'Total number of cases',
  totalPrice: 'Customer‘s total untaxed amount',
  totalPriceTax: 'Customer‘s total amount including tax',
  peerNumber:'Peer tracking number',
  createDate: 'Creation Date',
  orderValidDate: 'Order validity period',
  customerOrderNo: 'Purchase Order Number',
  productNo: 'Product No',
  shiptoNo: 'Customer Code (Ship To)',
  district: 'Detailed Address',
  materielNoTemp: 'Material Number',
  productName: 'Product Name',
  otsCustomerProductNo: 'Customer Product Code',
  containerSize: 'Container Size',
  packageQty: 'Package Quantity',
  orderBoxQty: 'Order Box Quantity (CS)',
  customerPriceNoTax: 'Customer Price per Box (Excluding Tax)',
  customerPrice: 'Customer Price per Box(Including Tax)',

  referencePriceNoTax: 'Reference Price per Box (Excluding Tax)',
  referencePrice: 'Reference Price per Box(Including Tax)',

  materielTypeNo: 'Material Type',
  categoryName: 'Category',
  pickUpFlag: 'Self-pickup',
  fullGoodsFlag: 'Ship when all goods are ready',
  outStockNotCloseFlag: 'Do not close order if out of stock',
  peerOrderFlag: 'Peer order',
  soldtoName: 'Sold-to Name',
  lineNumber: 'Line Number',
  preferenceFlag: 'Preference',
  grossWeight: 'grossWeight',
  netWeight: 'netWeight',
  volume: 'volume',
  whQty: 'Inventory Quantity',
  whNo: 'Warehouse Code',
  whCity: 'Warehouse City',
  msg:{
    peerNumber: 'Please enter a peer tracking number starting with 308',
    pickUpFlag: 'Self-pickup: please prepare the self-pickup authorization letter and contact the corresponding shipping DC;',
    peerOrderFlag: 'Peer order: requires adding the peer 308 order number',
    placeholder: 'Please select'
  },
  totalWeight: 'totalWeight',
  totalVolume: 'totalVolume'
};
export default soldCreate



// WEBPACK FOOTER //
// ./src/page/order/soldCreate/lang/soldCreate.en.js